<div
  [class]="`h-[calc(100vh-17.5rem)] overflow-y-auto ${!isRequestHeaderUiEnhancementEnabled() && 'h-[calc(100vh-9.5rem)]!'}`">
  <section class="my-lg flex justify-between">
    @if (isLoadingPositions()) {
      <div class="w-full flex justify-center">
        <lib-loader />
      </div>
    } @else {
      <lib-stepper
        [options]="stepperOptions()"
        [isVertical]="true"
        [descriptionTemplate]="descriptionTemplate" />

      <div class="flex flex-col justify-between py-3">
        @for (
          position of positions();
          track position.position_name;
          let i = $index
        ) {
          @let isParallel = position.steps.length > 1;
          @let contributors =
            isParallel ? [] : position.steps[0]?.details?.contributors || [];
          @let inProgressStep = stepperOptions()[i]?.status === 'active';
          @let inActiveStep = stepperOptions()[i]?.status === 'inactive';

          @if (!isParallel && (inProgressStep || contributors?.length)) {
            <div class="h-[2.75rem]">
              <ng-container
                [ngTemplateOutlet]="users_list"
                [ngTemplateOutletContext]="{
                  $implicit: contributors,
                  in_progress: inProgressStep,
                  position: position,
                  step: position.steps[0],
                }" />
            </div>
          } @else if (isParallel && !inActiveStep) {
            <div class="h-[2.75rem]" id="request-view-parallel-steps">
              <lib-dropdown-list
                [dropdownLabel]="
                  'request_screen_contributors_see_contributors_dropdown_label'
                    | transloco
                "
                [listTitle]="'request_screen_contributors_button' | transloco"
                [hasCloseButton]="true"
                [menuItems]="position.steps || []"
                containerRef="request-view-parallel-steps"
                [menuTemplateRef]="menuTemplate">
              </lib-dropdown-list>
            </div>
          } @else {
            <div class="h-[2.75rem]"></div>
          }
        }
      </div>
    }
  </section>
</div>

<ng-template #descriptionTemplate let-data>
  <span class="text-sm text-neutral-500">
    {{
      (data?.steps?.length > 1
        ? 'request_screen_contributors_positions_multiple_steps_label'
        : 'request_screen_contributors_positions_single_step_label'
      ) | transloco
    }}
    |
    <lib-badge
      [label]="
        data?.steps?.[0]?.details?.state?.label ??
        ('step_status_no_action' | transloco)
      "
      [badgeClass]="
        'px-sm border-none text-xs font-medium ' +
        (data?.steps?.[0]?.details?.state?.value ?? 'no_action' | stepStatus)
      " />
  </span>
</ng-template>

<ng-template
  #users_list
  let-contributors
  let-in_progress="in_progress"
  let-step="step">
  @let canAddContributors =
    isRequestAllowAction &&
    in_progress &&
    +currentStepId === +step?.details?.id;
  @let contributorsCount = step?.details?.contributors_count ?? 0;
  @let showCustomToggleButton = canAddContributors && contributorsCount === 0;
  @let inAddMode = showCustomToggleButton || isInAddMode();
  @let canRemoveContributors = canAddContributors && !inAddMode;

  @let currentList =
    inAddMode ? userDropdownList() : contributorsDropdownList();
  @let meta = inAddMode ? userDropdownMeta() : contributorsDropdownMeta();

  <lib-user-dropdown-view
    [userCount]="contributorsCount"
    [userTableList]="contributors"
    [userDropdownList]="currentList"
    [isDropdownLoading]="isLoadingDropdown()"
    [currentDropdownPage]="meta?.current_page ?? 0"
    [totalDropdownPages]="meta?.last_page ?? 0"
    [totalDropdownCount]="inAddMode ? (meta?.total ?? 0) : contributorsCount"
    [containerRef]="'request-view-stepper'"
    [showIndividualAvatar]="!contributorsCount"
    [allowLeftPositioning]="true"
    [enableDropdownIcon]="!!contributorsCount"
    [enableAddItem]="inAddMode"
    (addItem)="addContributor($event, step?.details?.id)"
    [enableDeleteItem]="canRemoveContributors"
    (deleteItem)="removeContributor($event, step?.details?.id)"
    [disableAddItem]="isApplyingActionContributor()"
    [disableDeleteItem]="isApplyingActionContributor()"
    [croppedNumber]="contributorsCount < 4 ? contributors?.length : 4"
    [trimLength]="18"
    [allowCustomToggleButton]="true"
    (handleMenuToggle)="
      inAddMode
        ? getUsers($event, step?.details?.id)
        : getStepContributors(step?.details?.id, $event)
    "
    (openedMenu)="resetDropdown()"
    [searchLabel]="'request_screen_contributors_button' | transloco"
    [searchPlaceholder]="
      'request_screen_contributors_search_placeholder' | transloco
    "
    [headerListLabel]="
      (inAddMode
        ? 'request_screen_contributors_list_header_label_add_mode'
        : 'request_screen_contributors_list_header_label'
      ) | transloco
    ">
    @if (showCustomToggleButton) {
      <div custom-list-toggle-button class="w-full flex">
        <ng-container [ngTemplateOutlet]="add_contributor" />
      </div>
    }

    @if (canRemoveContributors) {
      <div additional-menu-overlay-actions class="w-full">
        <button
          id="add-contributor"
          type="button"
          (click)="
            isInAddMode.set(true);
            getUsers({ currentPage: 1, search: '' }, step?.details?.id)
          "
          class="text-primary-500 flex justify-center items-center text-sm py-sm font-medium">
          <ng-container [ngTemplateOutlet]="add_contributor" />
        </button>
      </div>
    }
  </lib-user-dropdown-view>
</ng-template>

<ng-template #add_contributor let-alt_text>
  <p
    id="request_view_screen_request_action_section_contributors_add_contributor_button_label"
    class="text-primary-500 flex justify-center items-center text-sm py-sm font-medium">
    <lib-add-icon iconClass="size-4 text-primary-500 me-sm" />
    {{
      alt_text ?? ('request_screen_contributors_add_contributor' | transloco)
    }}
  </p>
</ng-template>

<ng-template #menuTemplate let-item let-index="i">
  @let contributors = item?.details?.contributors || [];
  @let inProgressStep =
    item?.details?.state?.value === StepStatusEnum().INPROGRESS ||
    item?.details?.state?.value === StepStatusEnum().ON_HOLD;

  <div class="w-full px-lg">
    <div class="border-b border-neutral-200">
      <div class="flex justify-between items-center gap-sm">
        <p class="text-xs font-semibold w-[10rem]">{{ item.name }}</p>
        <lib-badge
          [label]="
            item?.details?.state?.label ?? ('step_status_no_action' | transloco)
          "
          [badgeClass]="
            'w-max px-sm border-none text-xs font-medium ' +
            (item?.details?.state?.value ?? StepStatusEnum().NO_ACTION
              | parallelStepStatus)
          " />
      </div>

      <div class="w-fit">
        <ng-container
          [ngTemplateOutlet]="users_list"
          [ngTemplateOutletContext]="{
            $implicit: contributors,
            in_progress: inProgressStep,
            step: item,
          }" />
      </div>
    </div>
  </div>
</ng-template>
